module.exports = __webpack_public_path__ + "static/media/google.3755e9ec.jpg";